import styled from 'styled-components'

import { color, spacing, typography } from '../../../../themes'

export const Container = styled.div`
  display: flex;
  width: 100%;

  & svg {
    margin-top: 3px;
    height: 24px;
    width: 24px;
    min-width: 24px;
  }

  & > button {
    height: 24px;
  }
`

interface TitleWrapperProps {
  hasLeftContent?: boolean
  hasRightContent?: boolean
}

export const TitleWrapper = styled.div<TitleWrapperProps>`
  overflow: hidden;
  margin-left: ${({ hasLeftContent }) => (hasLeftContent ? spacing(2) : 0)};
  margin-right: ${({ hasRightContent }) => (hasRightContent ? spacing(2) : 0)};

  & > a {
    width: 100%;
    overflow: hidden;
  }
`

export type TitleVariant = 'primary' | 'secondary'

interface TitleProps {
  variant: TitleVariant
}

export const Title = styled.div<TitleProps>`
  ${({ variant }) =>
    typography(variant === 'primary' ? 'headline3' : 'subhead1')};
  color: ${color('gray.01')};
  display: flex;
  overflow: hidden;
`
